export function getTalentParkingLabel(parking?: string | null): string {
  if (parking === 'temp-pays' || parking === 'paid-on-site') return 'You pay for parking';
  if (parking === 'public-lot') return 'Pay Parking @ Public Lot';
  return parking || '';
}

export function getDOParkingLabel(parking?: string | null): string {
  if (parking === 'temp-pays' || parking === 'paid-on-site') return 'Temp pays for parking';
  if (parking === 'public-lot') return 'Pay Parking @ Public Lot';
  return parking || '';
}
